export default __webpack_public_path__ + "static/2017-3ce5e25b0b0c40a72106f01d4dbffd5a.svg";